import { useUpdateUserProfile } from "@/hooks/useUserProile";
import { authStateAtom } from "@/orm/auth";
import { Button, Card, Stack, TextInput } from "@mantine/core";
import { useAtomValue } from "jotai";
import { useState } from "react";

export const UserInfo = () => {
  const { user } = useAtomValue(authStateAtom);
  const [firstName, setFirstName] = useState(
    user?.displayName?.split(", ")[1] || "",
  );
  const [lastName, setLastName] = useState(
    user?.displayName?.split(", ")[0] || "",
  );
  const [update, loading] = useUpdateUserProfile();

  const handleUpdateProfile = async () => {
    if (!user) return;
    await update({ firstName, lastName });
  };

  return (
    <Card withBorder radius={0} h={"100%"}>
      <Stack>
        <TextInput
          size="lg"
          label="First Name"
          value={firstName}
          onChange={(e) => setFirstName(e.currentTarget.value)}
        />
        <TextInput
          size="lg"
          label="Last Name"
          value={lastName}
          onChange={(e) => setLastName(e.currentTarget.value)}
        />
        <TextInput size="lg" label="Email" value={user?.email || ""} disabled />
        <Button loading={loading} onClick={handleUpdateProfile}>
          Update Profile
        </Button>
      </Stack>
    </Card>
  );
};
